import React from 'react';
import { Typography, Fade } from '@mui/material';
import { GenerationPhase } from './chatUtils';

type GenerationStatusLineProps = {
  phase: GenerationPhase;
  visible: boolean;
};

const PHASE_COPY: Record<Exclude<GenerationPhase, 'idle' | 'streaming'>, string> = {
  reading: 'Reading your question…',
  context: 'Checking this SAT question…',
  drafting: 'Drafting a hint…',
};

const GenerationStatusLine: React.FC<GenerationStatusLineProps> = ({ phase, visible }) => {
  if (!visible || phase === 'idle' || phase === 'streaming') return null;

  const copy = PHASE_COPY[phase as keyof typeof PHASE_COPY];
  if (!copy) return null;

  return (
    <Fade in>
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', fontStyle: 'italic', mt: 0.5, fontSize: '0.8rem' }}
      >
        {copy}
      </Typography>
    </Fade>
  );
};

export default GenerationStatusLine;
